// extracted by css-extract-rspack-plugin
export default {"pill":"uQbAz","pillList":"sbK4m","input":"kdtaA","empty":"YeNwR","optionList":"zqsD3","option":"tgaFq"};